// removed by extract-text-webpack-plugin
module.exports = {"propertyCard":"c1_bh","imgWrap":"c1_ae","img":"c1_e","nav":"c1_c0","detailNav":"c1_c2","propertyCardResidential":"c1_c3","propertyCardLand":"c1_c4","propertyCardRental":"c1_c5","propertyCardCommercial":"c1_c6","propertyCardResidential_income":"c1_c7","body":"c1_aa"};


//////////////////
// WEBPACK FOOTER
// ./src/partials/property-card/property-card.module.scss
// module id = 605
// module chunks = 0